import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, Iffy } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  buttonContainer: {
    marginTop: 18,
    marginBottom: 18,
    borderRadius: 4,
    backgroundColor: colors['color-gray-600'],
  },
  whiteBackground: {
    backgroundColor: colors['color-text-white'],
  },
});

interface HeaderActionButtonsProps {
  isInContentPreviewModal?: boolean;
  displayExpandBtn?: boolean;
  isExpanded?: boolean;
  onClose?: () => void;
  onToggleSlideRollWidth?: () => void;
}

const HeaderActionButtons: React.FC<HeaderActionButtonsProps> = (props) => {
  const {
    isInContentPreviewModal,
    onClose,
    displayExpandBtn,
    isExpanded,
    onToggleSlideRollWidth,
  } = props;

  return (
    <DNABox alignX="end" spacing="sm">
      {/* CHEVRON BUTTON */}
      <Iffy is={displayExpandBtn}>
        <DNABox
          testID="chevron-button"
          appearance="row"
          alignX="center"
          alignY="center"
          style={styles.buttonContainer}
        >
          <DNAButton
            appearance="ghost"
            status="subtle"
            iconLeft={isExpanded ? 'caret-double-left' : 'caret-double-right'}
            colorMode="dark"
            onPress={onToggleSlideRollWidth}
          />
        </DNABox>
      </Iffy>

      {/* CLOSE BUTTON */}
      <Iffy is={!!onClose}>
        <DNABox
          testID="slide-roll-exit-button"
          appearance="row"
          alignX="center"
          alignY="center"
          style={[styles.buttonContainer, isInContentPreviewModal && styles.whiteBackground]}
        >
          <DNAButton
            appearance={isInContentPreviewModal ? 'outline' : 'ghost'}
            status={isInContentPreviewModal ? 'tertiary' : 'subtle'}
            colorMode={isInContentPreviewModal ? 'light' : 'dark'}
            iconLeft="x"
            onPress={onClose}
          />
        </DNABox>
      </Iffy>
    </DNABox>
  )
}

export default HeaderActionButtons;
